import { formatInTimeZone } from 'date-fns-tz'

const pattern = 'hh:mm a';
    
const timeZone = "UTC";

const formateTimeSlot = (start:string, end:string):string => {
    start = new Date(start).toLocaleTimeString([], { timeZone: timeZone, hour: '2-digit', minute:'2-digit' })
    end = new Date(end).toLocaleTimeString([], { timeZone: timeZone, hour: '2-digit', minute:'2-digit' })
    
    return `${start} - ${end}`
}

const formatDate = (date: Date, timeZone?: string, format?: string) => {
    if(date) {
        timeZone = timeZone ? timeZone : 'UTC'
        format = format ? format : 'LLL d, yyyy'

        return formatInTimeZone(new Date(date), timeZone, format)
    }

    return '--';
}

const formatTime = (date: Date, timeZone?: string, format?: string) => {
    if(date) {
        timeZone = timeZone ? timeZone : 'UTC'
        format = format ? format : 'hh:mm:ss'


        return formatInTimeZone(new Date(date), timeZone, format)
    }

    return '--';
}


const formatDateTime = (date: Date, timeZone?: string) => {
    if(date) {
        timeZone = timeZone ? timeZone : 'UTC'

        return formatInTimeZone(new Date(date), timeZone, 'MMM dd, yyy (h:mm a)')
    }

    return '--';
}
export {
    pattern,
    timeZone,
    formateTimeSlot,
    formatDate,
    formatTime,
    formatDateTime,
};